<template>
  <model-table
    :collection="deliveryLocations"
    orderable
    :order-options="['name']"
    :columns="[
      { field: 'id' },
      { field: 'name' },
      { name: 'type', field: (deliveryLocation) => $_.startCase(deliveryLocation.type), component: 'chip' },
      { field: 'positions', component: 'chips', limitValues: 6 },
      { name: 'library', component: 'library-link', hide: currentCircuit.isLibrary },
      { name: 'actions', label: 'Action', align: 'right' }
    ]"
    :has-library="!currentCircuit.isLibrary"
    :library-collection="deliveryLocationLibrary"
    :library-columns="[
      { field: 'name' },
      { name: 'type', field: (deliveryLocation) => $_.startCase(deliveryLocation.type), component: 'chip' },
      { field: 'positions', component: 'chips', limitValues: 6 }
    ]"
    :link-filter="libraryFilterFunction"
  >
    <delivery-location-form
      ref="deliveryLocationForm"
    />
  </model-table>
</template>

<script>

import ModelTable from 'src/modules/admin/components/ModelTable'
import DeliveryLocationForm from 'src/modules/admin/delivery-location/DeliveryLocationForm'

export default {
  name: 'DeliveryLocationTable',
  components: {
    ModelTable,
    DeliveryLocationForm
  },
  configuration: ['currentCircuit'],
  models: {
    deliveryLocations: {
      libraryParentId: true,
      receiveLibraryUpdates: true
    },
    deliveryLocationLibrary: {
      libraryChildSiteIds: true,
      variables () {
        return {
          searchString: this.libraryFilterString,
          limit: 10
        }
      },
      immediate: true
    }
  },
  data () {
    return {
      libraryFilterString: null
    }
  },
  methods: {
    libraryFilterFunction (value) {
      this.libraryFilterString = !_.isEmpty(value) ? value.trim() : null
    }
  }
}
</script>
